'use client';
import { useEffect } from 'react';
import { useHasHoverSupport } from '@THC/hooks';
import { useConstantCallback } from './useConstantCallback';
export const useHover = (ref, handler) => {
    const constantHandler = useConstantCallback(handler);
    const hasHoverSupport = useHasHoverSupport();
    useEffect(() => {
        if (!hasHoverSupport) {
            return undefined;
        }
        const refElement = ref.current;
        if (!refElement) {
            return undefined;
        }
        const onMouseEnter = (event) => constantHandler({ event, isHovered: true });
        const onMouseLeave = (event) => constantHandler({ event, isHovered: false });
        refElement.addEventListener('mouseenter', onMouseEnter, { passive: true });
        refElement.addEventListener('mouseleave', onMouseLeave, { passive: true });
        return () => {
            refElement.removeEventListener('mouseenter', onMouseEnter);
            refElement.removeEventListener('mouseleave', onMouseLeave);
        };
    }, [constantHandler, hasHoverSupport, ref]);
};
